var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutofservice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#FFDC83"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6875 9.08505L8.65406 16.0712C7.69246 17.7367 5.61048 16.5347 6.57207 14.8692L10.6055 7.88302C9.07216 5.51721 10.3757 2.93883 13.0596 2.8845L12.3651 4.08745C11.0562 6.35447 13.8322 7.95717 15.141 5.69016L15.8355 4.48721C17.255 7.15733 15.5492 9.25705 12.6875 9.08503L12.6875 9.08505ZM8.86117 14.2167L8.27352 15.2345C7.92626 15.836 7.13977 15.3819 7.48702 14.7804L8.07467 13.7626C8.42193 13.1611 9.20842 13.6152 8.86117 14.2167Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutofservice);
export default __webpack_public_path__ + "static/media/Outofservice.581093f289d311d62720439646db3ebf.svg";
export { ForwardRef as ReactComponent };